import {
  useEffect,
  useCallback,
  useState,
  useMemo,
  forwardRef,
  useRef,
  useImperativeHandle,
  memo,
} from "react";
import { Checkbox, Icon } from "@mui/material";
import { FontAwesome } from "../../../../../../components/icon";
import { useSelector } from "react-redux";
import DeniedBoSungVanDesEndpoint from "../../../../../../service/Meet/DeniedBoSungVanDesEndpoint";
import { TOKEN_CLIENT_INFO } from "../../../../../../actions/constants";
import { ThanhPhanThamDusEndpoint } from "../../../../../../service/Meet";

const ThamDus = forwardRef(({ dataVD }, ref) => {
  const [listDeny, setListDeny] = useState([]);
  const { thamDus, phienHop } = useSelector((state) => state.meetingRProcess);
  const isDetail = useRef(false);
  const [canBos, setCanBos] = useState(null);

  useImperativeHandle(ref, () => ({ getDeny: () => listDeny || [] }), [
    listDeny,
  ]);

  const getThamDus = useCallback(async (data) => {
    try {
      if (data?.deniedBoSungVanDes || data?.denieds) {
        setListDeny(data?.deniedBoSungVanDes || data?.denieds);
        isDetail.current = true;
      }
    } catch (error) {}
  }, []);

  const getLisCanBos = useCallback(async (phienHop) => {
    try {
      const { value } = await ThanhPhanThamDusEndpoint.getDataWithPhienHopId(
        phienHop.id,
      );
      setCanBos({ thamGia: value });
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    if (thamDus) {
      setCanBos(thamDus);
    } else {
      phienHop && getLisCanBos(phienHop);
    }
  }, [getLisCanBos, phienHop, thamDus]);

  useEffect(() => {
    dataVD && getThamDus(dataVD);
  }, [dataVD, getThamDus]);

  const handleDeny = useCallback(
    (idThamDu, checked) => {
      setListDeny((pre) => {
        const data = [...pre];
        if (checked) {
          dataVD.id &&
            DeniedBoSungVanDesEndpoint.deleteDeny({
              boSungVanDeId: dataVD.id,
              thanhPhanThamDuId: idThamDu,
            });
          const index = data.findIndex((cur) => cur === idThamDu);
          if (index > -1) data.splice(index, 1);
        } else {
          dataVD.id &&
            DeniedBoSungVanDesEndpoint.addDeny({
              boSungVanDeId: dataVD.id,
              thanhPhanThamDuId: idThamDu,
            });
          data.push(idThamDu);
        }
        return data;
      });
    },
    [dataVD],
  );

  const totalCount = canBos?.thamGia?.length || 0;
  const activeCount = totalCount - listDeny.length;

  const renderThamDus = useMemo(() => {
    const cb = canBos ? canBos?.thamGia : [];
    return (
      cb &&
      cb.map((cur, i) => {
        const { nhanSu, khachMoi } = cur;
        const name = nhanSu
          ? nhanSu.thongTinCaNhan.hoVaTenDem + ` ` + nhanSu.thongTinCaNhan.ten
          : khachMoi.name;
        const role = nhanSu?.chucDanh?.name || "Khách mời";
        const isActive = !listDeny.includes(cur.id);
        const initials =
          name.trim().split(" ").pop()?.charAt(0)?.toUpperCase() || "?";
        return (
          <div
            key={cur.id || i}
            className={`td-participant-card ${isActive ? "active" : "denied"}`}
          >
            <div className={`td-avatar ${isActive ? "" : "denied"}`}>
              {initials}
            </div>
            <div className="td-info">
              <span className="td-name">{name}</span>
              <span className="td-role">{role}</span>
            </div>
            <Checkbox
              disabled={TOKEN_CLIENT_INFO.role !== "QLH"}
              checked={isActive}
              size="small"
              sx={{
                color: "#d1d5db",
                "&.Mui-checked": { color: "#059669" },
                padding: "4px",
              }}
              inputProps={{ "aria-label": name }}
              onChange={(e, check) => {
                handleDeny(cur.id, check);
              }}
            />
          </div>
        );
      })
    );
  }, [canBos, handleDeny, listDeny]);

  return (
    <>
      <div className="td-header">
        <div className="td-header-left">
          <Icon sx={{ fontSize: 20, color: "#059669" }}>how_to_reg</Icon>
          <span className="td-header-title">Danh sách tham dự</span>
        </div>
        <span className="td-header-count">
          {activeCount}/{totalCount}
        </span>
      </div>
      <div className="list-thamDus">{renderThamDus}</div>
    </>
  );
});

export default memo(ThamDus);
